import React from "react";
import useCobroAspirantes from "../hooks/useCobroAspirantes";
import VistaCobroAspirantes from "./VistaCobroAspirantes";

const CobroAspirantes = ({ user }) => {
  const aspirantesProps = useCobroAspirantes(user);

  return (
    <VistaCobroAspirantes {...aspirantesProps} />
  );
};

export default CobroAspirantes;